import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { registerResource, resolveResource } from '../../../store/screenSlice'
import { getVideoType } from '../utils'
import { Audio } from '../../Audio/Audio'
import styles from '../VideoScreen.module.scss'


class SafariVideoBody extends Component {
    constructor(props, context) {
        super(props, context)

        this.wrapperId = `safari-video-wrapper-${Math.random()}`
        this.videoId = `safari-video-${Math.random()}`
        this.onLoadFunctionName = `safariVideoOnLoad${Date.now()}`
        this.onTimeUpdateName = `safariVideoOnTimeUpdate${Date.now()}`

        this.audioRef = React.createRef()
    }

    componentDidMount() {
        const { playing, videoSrc, registerResource, resolveResource, onTimeUpdate } = this.props

        registerResource(videoSrc)

        this.wrapperEl = window.document.getElementById(this.wrapperId)

        const videoType = getVideoType(videoSrc)

        window[this.onLoadFunctionName] = () => {
            resolveResource(videoSrc)
        }

        window[this.onTimeUpdateName] = () => {
            // const { videoEl } = this
            const audioEl = this.audioRef.current

            // audioEl.currentTime = videoEl.currentTime
            audioEl.play()

            onTimeUpdate(this.videoEl)

            window[this.onTimeUpdateName] = () => {
                onTimeUpdate(this.videoEl)
            }
        }

        this.wrapperEl.innerHTML = `
            <video
                id="${this.videoId}"
                class="${styles.video}"
                preload="auto"
                playsinline
                muted
                onload="${this.onLoadFunctionName}()"
                onloadeddata="${this.onLoadFunctionName}()"
                onerror="${this.onLoadFunctionName}()"
                ontimeupdate="${this.onTimeUpdateName}()"
            >
                <track kind="captions" />
                <source src="${videoSrc}" type="${videoType}" />
            </video>
        `

        this.videoEl = window.document.getElementById(this.videoId)

        if (playing) {
            this.videoEl.play()
            // this.audioRef.current.play()
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { playing } = this.props

        if (this.audioRef.current && !playing && nextProps.playing) {
            this.videoEl.play()
            // this.audioRef.current.play()
        }

        return false
    }

    componentWillUnmount() {
        // Сразу удалять колбэки нельзя, они еще могут стрельнуться раз-два
        // Но делать они ничего не должны
        window[this.onLoadFunctionName] = () => {}
        window[this.onTimeUpdateName] = () => {}

        setTimeout(() => {
            delete window[this.onLoadFunctionName]
            delete window[this.onTimeUpdateName]
        }, 5 * 1000)

        this.wrapperEl.innerHTML = ''
        this.videoEl = null
    }

    render() {
        const { audioSrc } = this.props

        return (
            <>
                <div id={this.wrapperId} />

                <Audio
                    audioRef={this.audioRef}
                    src={audioSrc}
                />
            </>
        )
    }
}

SafariVideoBody.propTypes = {
    playing: PropTypes.bool.isRequired,
    videoSrc: PropTypes.string.isRequired,
    audioSrc: PropTypes.string,
    onTimeUpdate: PropTypes.func.isRequired,
    registerResource: PropTypes.func.isRequired,
    resolveResource: PropTypes.func.isRequired,
}

const SafariVideo = connect(
    null,
    {
        registerResource,
        resolveResource,
    },
)(SafariVideoBody)

SafariVideo.propTypes = {
    playing: PropTypes.bool.isRequired,
    videoSrc: PropTypes.string.isRequired,
    audioSrc: PropTypes.string,
    onTimeUpdate: PropTypes.func.isRequired,
}

export { SafariVideo }
